

/* profile-menu-dialog.component.ts */
import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AddressPublic, AddressType, UpdateAddressVariables } from '../../../../globalTypes/account.types';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from "../../component/layout/element/button.component";
import { Store } from '@ngrx/store';
import { AccountActions, accountFeature } from '../../store/account.store';
import { Logger } from '../../helper/logger';
import { lastValueFrom, take } from 'rxjs';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { Functions } from '@angular/fire/functions';
import { onCallFunctions } from '../../../../globalTypes/backend.api.types';
import { LimiterDirective } from '../../directive/limiter';
import { LOCATION_LABEL } from '../../../../globalTypes/configs';
const log = new Logger("AddressDialog");
export interface AddressData {
  address: AddressPublic
  addressType: AddressType
}

@Component({
  selector: 'msh-address-dialog',
  standalone: true,
  imports: [MatIconModule, FormsModule, MatDialogModule, MatButtonModule, RouterModule, ButtonComponent, LimiterDirective],
  template: `
<div class=" z-10 relative">
  <mat-icon class="absolute top-4 right-4" [mat-dialog-close]="false">close</mat-icon>
</div>
<div class="dialog-container relative p-4 px-10 overflow-auto max-h-96 ">
  <div>
    <input 
      type="text"
      placeholder="Attn"
      name="attn"
      [limiter]="100"
      [(ngModel)]="address.attn"
      required />
  </div>
  <div class="flex gap-4">
    <div>
      <input 
        type="text"
        placeholder="Street No."
        name="streetNumber"
        [(ngModel)]="address.streetNumber"
        [limiter]="100"
        class=" !w-24"
        required />
    </div>
    <div>
      <input 
        type="text"
        placeholder="Address"
        name="address"
        [limiter]="100"
        [(ngModel)]="address.address"
        required />
    </div>
  </div>
    
  <div class="grid grid-cols-3 gap-3">
    <div>
      <input 
        type="text"
        placeholder="City"
        name="city"
        [(ngModel)]="address.city"
        [limiter]="100"
        required />
    </div>
    <div>
      <input 
        type="text"
        placeholder="State"
        name="state"
        [(ngModel)]="address.state"
        [limiter]="100"
        required />
    </div>
    <div>
      <input 
        type="text"
        placeholder="Postcode"
        name="postcode"
        [(ngModel)]="address.postcode"
        [limiter]="16"
        required />
    </div>
  </div>
</div>

<div class="bg-navy-50 gap-4 py-4 px-6 flex justify-end">
    <msh-button [cta]="'Update'" (onClick)="updateAddress()" [disabled]="!address || !address.address || !address.city || !address.state || !address.postcode" [mat-dialog-close]="data.address"></msh-button>
</div>
  `,
  styles: ``
})
export class AddressDialog {

  address!: AddressPublic;
  
  constructor(
    private functions: Functions,
    private store: Store,
    public dialogRef: MatDialogRef<AddressDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AddressData,
  ){
    this.address = (this.data.address) ? JSON.parse(JSON.stringify(this.data.address)) : {};
  }

  async updateAddress(){
    const {id, streetNumber, address, city, state, postcode, attn} = this.address;
    let addressUpdate
    const location = await lastValueFrom(this.store.select(accountFeature.selectLocation).pipe(take(1)))
    if(!location) throw new Error("No current "+LOCATION_LABEL+" available to attach address to")
    let processorUserId;
    const vars: UpdateAddressVariables = {
      id, streetNumber, address, city, state, postcode, attn: attn || '',
      validationId: '',
      validationStatus: '_user_updated_',
      locationId: location.id,
    }
    
    log.log({address}) // TODO check why attn doesn't get saved to the store
    // Update Shippo address too
    const callable = httpsCallable(this.functions,  onCallFunctions.updateAddressAndShippoAddressId)
    const results: HttpsCallableResult = await callable(vars)
    this.store.dispatch(AccountActions.updateAddress({address: this.address, addressType: this.data.addressType}))
    this.dialogRef.close({id, streetNumber, address, city, state, postcode, attn})
  }

}
